<template>
  <CRow class="w-100 h-100 justify-content-center pageError">
    <CCol sm="12" class="d-flex">
      <div class="w-100 d-flexflex-column justify-content-center align-items-center">
        <kinesis-container class="container d-flex flex-column justify-content-center align-items-center">
          <!-- background-circles-props -->
          <kinesis-element :strength="25" type="depth">
            <img src="@/assets/imgs/stars.png" class="stars" alt="" />
          </kinesis-element>
          <kinesis-element :strength="25" type="depth">
            <img src="@/assets/imgs/planet.png" class="planet" alt="" />
          </kinesis-element>
          <kinesis-element :strength="10" type="depth">
            <img src="@/assets/imgs/astro.png" class="astro" alt="" />
          </kinesis-element>
        </kinesis-container>
      </div>
    </CCol>
    <div class="z-index-10 d-flex flex-column justify-content-center align-items-center">
      <h4 class="text-uppercase mt-5 mb-3 font-weight-normal">
        {{ $t('error.page.404.title') }}
      </h4>
      <p class="text-gray-600">{{ $t('error.page.404.subTitle') }}</p>
      <CButton color="primary" @click="$router.push({ name: 'home', params: organizationParam })">{{ $t('error.page.404.linkHome') }}</CButton>
    </div>
  </CRow>
</template>

<script>
export default {
  name: 'Page404',
  data() {
    return {
      organizationParam: {},
    }
  },
  mounted() {
    if (this.$route.query.organizationId) {
      this.organizationParam.organizationId = this.$route.query.organizationId
    }
  },
}
</script>

<style lang="scss" scope>
.pageError {
  .container {
    max-width: 1280px;
    width: 100%;
    height: 70vh;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }

  img {
    width: 50%;
    &.astro {
      animation: float 6s ease-in-out infinite;
      transform: translateX(60%) translateY(-200%);
    }
    &.planet {
      animation: floatPLanet 5s ease-in-out infinite;
      transform: translateX(50%) translateY(10%);
    }
    &.stars {
      transform: translateX(50%) translateY(50%);
    }
  }

  .z-index-10 {
    z-index: 50;
  }

  @keyframes float {
    0% {
      transform: translateX(50%) translateY(-200%);
    }
    50% {
      transform: translateX(50%) translateY(-205%);
    }
    100% {
      transform: translateX(50%) translateY(-200%);
    }
  }
  @keyframes floatPLanet {
    0% {
      transform: translateX(50%) translateY(2%);
    }
    50% {
      transform: translateX(50%) translateY(0%);
    }
    100% {
      transform: translateX(50%) translateY(2%);
    }
  }
}
</style>
